import { TTypeInput } from "../../components/ui/Input/Input";

export type TypeIdGeneral =
  | "firstname"
  | "lastname"
  | "username"
  | "email"
  | "password";

type InputGeneralBase = {
  id: TypeIdGeneral;
  label: string;
  placeholder: string;
};

type InputGeneralString = InputGeneralBase & {
  type: TTypeInput | "password";
  value: string;
};

export type IInputGeneral = InputGeneralString;

export const inputGeneral: IInputGeneral[] = [
  {
    id: "firstname",
    type: "text",
    label: "FirstName",
    value: "",
    placeholder: "John",
  },
  {
    id: "lastname",
    type: "text",
    label: "LastName",
    value: "",
    placeholder: "Doe",
  },
  {
    id: "username",
    type: "text",
    label: "userName",
    value: "",
    placeholder: "Doe",
  },
  {
    id: "email",
    type: "email",
    label: "Email",
    value: "",
    placeholder: "example@mail.com",
  },
  {
    id: "password",
    type: "password",
    label: "Passwort",
    value: "",
    placeholder: "Enter password",
  },
];
